import React, { useEffect, useState } from 'react';
import { Button, Modal, InputGroup} from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import Field from '../../Wizard/Field/Field';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';
import { Typeahead } from 'react-bootstrap-typeahead';

function CreatePersonModal(props) {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const myRef = React.useRef<any>();

    const [autoCompleteOptions, setAutoCompleteOptions] = useState<Array<any>>([]);
    const [autoCompleteOrgOptions, setAutoCompleteOrgOptions] = useState<Array<any>>([]);
    const [newPersonCopyof, setNewPersonCopyof] = useState("");
    const [newPersonOrganization, setNewPersonOrganization] = useState("");
    const [newPersonCompanyRegistrationId, setNewPersonCompanyRegistrationId] = useState("");

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const [newPersonLastName, setNewPersonLastName] = useState("");
    const [newPersonFirstName, setNewPersonFirstName] = useState("");
    const [newPersonEmail, setNewPersonEmail] = useState("");
    const [newPersonPhone, setNewPersonPhone] = useState("");
    const [newPersonDescription, setNewPersonDescription] = useState("");

    function clearForm(){
        setNewPersonLastName("");
        setNewPersonFirstName("");
        setNewPersonEmail("");
        setNewPersonPhone("");
        setNewPersonOrganization("");
        setNewPersonCompanyRegistrationId("")
    }

    function handleCreatePerson() {
        if (newPersonLastName == "" || newPersonLastName == undefined) { notifyWarning(t("people.toast_persons_empty_name")); return undefined; }
        if (newPersonEmail !== "undefined") {
            let pattern = new RegExp(/^$|^([\w\.\-]+)@([\w\-]+)((\.(\w){2,})+)$/);
            if (!pattern.test(newPersonEmail)) {
                notifyWarning(t("people.toast_people_invalidemail"));
                return undefined;
            }
        }
        if(newPersonFirstName == "" || newPersonFirstName == undefined) {notifyWarning(t("people.toast_persons_empty_Firstname")); return undefined;}

        axios.post(
            "/api/persons",
            {
                lastname: newPersonLastName,
                firstname: newPersonFirstName,
                email: newPersonEmail,
                phone: newPersonPhone,
                organization: newPersonOrganization,
                companyregistrationId: newPersonCompanyRegistrationId,
                description: newPersonDescription,
                copyof: newPersonCopyof,
            },
            {
                headers: {'x-access-token': auth.user["token"]}
            }
        ).then(res => {
            if (props.onSaveNew != undefined) props.onSaveNew(res.data);
            
            if(res.data.duplicate == true){ 
             notifySuccess(t("people.toast_people_duplicate"))}
            else{
                notifySuccess(t("people.toast_people_created"));  
             }
             
            clearForm();
        });
    }

    const newPersonNameChange = (value) => {
        if (value.length > 1) {
            axios.post('/api/persons/search',
            {
                filter: value
            }, {
                headers: {'x-access-token': auth.user["token"]}
            })
            .then(function (response) {
                let autoCompleteGuestInCustomerOrganization = props.customer != undefined ? response.data.filter(c => c.organization == props.customer.organizationName) : response.data;
                setAutoCompleteOptions(autoCompleteGuestInCustomerOrganization.map(item => { return { id: item._id, label: item.lastname, data: item }}));
            }, {
                headers: {'x-access-token': auth.user["token"]}
            });
        }
        setNewPersonLastName(value);
    };

    const newPersonOrganizationChange = (value) => {
        /*if (value.length > 1) {
            axios.all([
                axios.single({
                    method: "post",
                    url: "/api/customers/search/org",
                    data: {
                        filter: value
                    },
                    responseType: "json",
                    headers: { 'x-access-token': auth.user["token"] }
                })
            ]).then(axios.spread((...res) => {
                    let orgOptionsList: Array<any> = [];
                    let autoCompleteOptionsList: Array<any> = [];
                    let customersOrgOptions = res[0].data;
                    customersOrgOptions.forEach((customer) => {
                        if(!orgOptionsList.map(i => i.organizationName).includes(customer.organizationName)){
                            orgOptionsList.push(customer);
                            autoCompleteOptionsList.push({ id: customer._id, label: customer.organizationName, data: customer });
                        } 
                    });
                    setAutoCompleteOptions(autoCompleteOptionsList);
                }))
                .catch(err => console.log(err));
        }*/
        
        setNewPersonOrganization(value);
    };
    
    function fetchData() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/customers/",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
        ])
        .then(axios.spread((...res) => {
            let autoCompleteOptionsList: Array<any> = [];
            res[0].data.forEach((customer) => {
                autoCompleteOptionsList.push({
                    id: customer._id,
                    label: customer.organizationName != undefined && customer.organizationName != "" ? customer.organizationName : (customer.lastname + " " + customer.firstname),
                    data: customer
                });
            });
            setAutoCompleteOrgOptions(autoCompleteOptionsList);
        }));
    }

    useEffect(() => {
        fetchData();
    }, [props.show]);

    const handleKeyDownPersonCreate = event => {
        if (event.key === 'Enter' ) {
            handleCreatePerson();
        }
    }
    
    return (
        <Modal show={props.show} onHide={() => { if(props.onHide != undefined) props.onHide(); }}> 
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("people.new")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.onSelectExisting != undefined ?
                    <InputGroup className="mb-3">
                        <InputGroup.Prepend>
                            <InputGroup.Text>{t("people.lastname")  + '*'}</InputGroup.Text>
                        </InputGroup.Prepend>
                        <Typeahead
                            id="newPersonLastNameInput"
                            onInputChange={newPersonNameChange}
                            className="typeaheadinput"
                            onChange={items => {
                                if (items.length > 0) {
                                    if (items[0]["id"] != undefined && items[0]["id"] != "") {
                                        let selectedOption = (props.people.find(item => item["_id"] == items[0]["id"]) as any);
                                        if (props.onSelectExisting != undefined) {
                                            
                                            props.onSelectExisting(selectedOption);
                                        }
                                        clearForm();
                                    } else {
                                        setNewPersonCopyof(""); 
                                    }
                                    newPersonNameChange(items[0]["label"])
                                } else {
                                    setNewPersonCopyof("");
                                }
                            }}
                            renderMenuItemChildren={(option, props, index) => {
                                return(
                                    <div>
                                        <p style={{lineHeight: "16px", marginBottom: "0px"}}>
                                            <span style={{ fontSize: "11px" }}>{option.data.organization}</span><br/>
                                            <span style={{ fontSize: "12px" }}>{option.data.email} | {option.data.phone}</span><br/>
                                            <span>{option.data.lastname}, {option.data.firstname}</span>
                                        </p>
                                        <hr/>
                                    </div>
                                );
                            }}
                            onKeyDown={handleKeyDownPersonCreate}
                            ref={myRef}
                            minLength={2}
                            emptyLabel={t("person.no_results")}
                            options={autoCompleteOptions} 
                        />
                    </InputGroup>
                :
                    <Field
                        type="input"
                        title={t("people.lastname") + '*'}
                        value={newPersonLastName}
                        onChange={value => setNewPersonLastName(value)}
                    ></Field>
                }
                 <Field
                    type="input"
                    title={t("people.firstname") + '*'}
                    value={newPersonFirstName}
                    onChange={value => setNewPersonFirstName(value)}
                ></Field>
                {/* <Field
                    type="input"
                    title={t("people.organization")}
                    value={ newPersonOrganization}
                    onChange={value => setNewPersonOrganization(value)}
                ></Field> */}
                <Field
                    type="input"
                    title={t("people.email")}
                    value={newPersonEmail}
                    onChange={value => setNewPersonEmail(value)}
                ></Field>
                <Field
                    type="input"
                    title={t("people.phone")}
                    value={newPersonPhone}
                    onChange={value => setNewPersonPhone(value)}
                ></Field>
                  <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text>{t("people.organization")}</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Typeahead
                        id="newPersonOrganizationInput"
                        onInputChange={newPersonOrganizationChange}
                        className="typeaheadinput"
                        onChange={items => {
                            if (items.length > 0) {
                                newPersonOrganizationChange(items[0]["label"])
                            } else return null;
                        }}
                        ref={myRef}
                        minLength={2}
                        emptyLabel={t("person.no_results")}
                        options={autoCompleteOrgOptions} 
                    />
                </InputGroup>
                <Field
                    type="input"
                    title={t("customer.companyRegistrationId")}
                    value={newPersonCompanyRegistrationId}
                    onChange={value => setNewPersonCompanyRegistrationId(value)}
                ></Field>
                <Field
                    type="textarea"
                    title={t("people.description")}
                    value={newPersonDescription}
                    onChange={value => setNewPersonDescription(value)}
                ></Field>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => { if(props.onCancel != undefined) props.onCancel(); }}>
                    {t("people.cancel")}
                </Button>
                <Button onClick={handleCreatePerson}>
                    {t("people.save")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CreatePersonModal;